exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "a{color:inherit;text-decoration:none;cursor:pointer!important;pointer-events:all;-webkit-user-select:none;user-select:none;-webkit-touch-callout:none}p{margin-bottom:12px}ol{list-style:inside}.expandableList{position:relative;top:0;max-width:1000px;height:100%;display:block;margin-bottom:100px}.expandableList-headline{width:100%;display:block;margin:0 0 30px;font-size:34px;font-weight:700;line-height:36px;font-family:LabilGrotesk}.scrolledSections .expandableList-headline{margin:0 0 30px}.scrolledSections .expandableList-expandableGroup:not(:first-child){margin:72px 0 0}.expandableList-image{margin-top:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?minimize!../node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-bde14ed4","scoped":false,"hasInlineConfig":false}!../node_modules/sass-loader/lib/loader.js?indentedSyntax!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/combinedBlocks/ExpandableList.vue
// module id = 474
// module chunks = 0